import column_flex from '../components/Driverless_column_flex'

export default {
  data () {
    return {
    }
  },
  props: ['width', 'company_lists', 'column-width'],
  mounted () {
    this.$refs.blue_box.style.width = this.width * 10 + "px"
  },
  components: {
    'column-flex': column_flex
  }
}



// WEBPACK FOOTER //
// ./src/supplychain/js/driverless_box.js